// @mui
import { Chip, Stack, TextField, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { UseFormReturn } from 'react-hook-form/dist/types';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
}));

// ----------------------------------------------------------------------

type Props = {
  form: UseFormReturn;
};

export default function FormContactDetails({ form }: Props) {
  const {
    register,
    formState: { errors },
  } = form;

  return (
    <RootStyle>
      <Stack spacing={2.5}>
        <Stack spacing={2} direction="row" alignItems="center" sx={{ mb: 2.5 }}>
          <Chip label="2" />
          <Typography variant="h5">Kontaktinfo</Typography>
        </Stack>
        <TextField
          type="text"
          helperText={errors.name?.message}
          error={!!errors.name}
          fullWidth
          label="Navn*"
          {...register('name')}
        />
        <Stack spacing={{ md: 2.5, xs: 2.5 }} direction={{ md: "row", xs: "column" }}>

          <TextField
            type="tel"
            helperText={errors.phone?.message}
            error={!!errors.phone}
            fullWidth
            label="Telefonnummer*"
            {...register('phone')}
          />
          <TextField
            type="email"
            helperText={errors.email?.message}
            error={!!errors.email}
            fullWidth
            label="Email*"
            {...register('email')}
          />
        </Stack>

      </Stack>
    </RootStyle>
  );
}
